import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getFechasSenaladas,
  deleteFechaSenalada,
  updateFechaSenalada,
  getFechaSenaladaById,
  insertFechaSenalada,
  updateFechaSenaladaAll,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_FECHAS_SENALADAS() {
  try {
    const fechasSenaladasData = yield call(getFechasSenaladas)
    if (fechasSenaladasData.ok) {
      yield put({
        type: actions.FECHAS_SENALADAS_LOAD_SUCCEEDED,
        payload: fechasSenaladasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar fechas señaladas')
      put({
        type: actions.FECHAS_SENALADAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FECHAS_SENALADAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_FECHA_SENALADA_BY_ID(action) {
  try {
    const fechaSenaladaData = yield call(getFechaSenaladaById, action.payload)
    if (fechaSenaladaData.ok) {
      yield put({
        type: actions.FECHA_SENALADA_BYID_LOAD_SUCCEEDED,
        payload: fechaSenaladaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar fecha señalada')
      put({
        type: actions.FECHA_SENALADA_BYID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FECHA_SENALADA_BYID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FECHA_SENALADA(action) {
  try {
    const fechaSenaladaObj = yield call(updateFechaSenalada, action.payload)
    if (fechaSenaladaObj.ok) {
      putMessage(messageType.SUCCESS, 'Fecha Señalada modificada correctamente')
      yield put({
        type: actions.FECHA_SENALADA_UPDATE_SUCCEEDED,
        payload: fechaSenaladaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Fecha Señalada')
      yield put({
        type: actions.FECHA_SENALADA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Fecha Señalada')
    yield all([
      put({
        type: actions.FECHA_SENALADA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_FECHA_SENALADA(action) {
  try {
    const fechaSenaladaResult = yield call(deleteFechaSenalada, action.payload)
    if (fechaSenaladaResult.ok) {
      putMessage(messageType.SUCCESS, 'Fecha Señalada eliminada correctamente')
      yield put({
        type: actions.FECHA_SENALADA_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Fecha Señalada')
      yield put({
        type: actions.FECHA_SENALADA_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Fecha Señalada')
    yield all([
      put({
        type: actions.FECHA_SENALADA_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_FECHA_SENALADA(action) {
  try {
    const fecaSenaladaObj = yield call(insertFechaSenalada, action.payload)
    if (fecaSenaladaObj.ok) {
      putMessage(messageType.SUCCESS, 'Fecha Señalada creada correctamente')
      yield put({
        type: actions.FECHA_SENALADA_INSERT_SUCCEEDED,
        payload: fecaSenaladaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear fecha señalada')
      yield put({
        type: actions.FECHA_SENALADA_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear fecha señalada')
    yield all([
      put({
        type: actions.FECHA_SENALADA_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FECHA_SENALADA_ALL(action) {
  try {
    const fechaSenaladaObj = yield call(updateFechaSenaladaAll, action.payload)
    if (fechaSenaladaObj.ok) {
      putMessage(messageType.SUCCESS, 'Fecha Señalada modificada correctamente')
      yield put({
        type: actions.FECHA_SENALADA_UPDATE_ALL_SUCCEEDED,
        payload: fechaSenaladaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar fecha Señalada')
      yield put({
        type: actions.FECHA_SENALADA_UPDATE_ALL_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar fecha Señalada')
    yield all([
      put({
        type: actions.FECHA_SENALADA_UPDATE_ALL_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FECHAS_SENALADAS_LOAD_REQUESTED, GET_FECHAS_SENALADAS),
    takeEvery(actions.FECHA_SENALADA_BYID_LOAD_REQUESTED, GET_FECHA_SENALADA_BY_ID),
    takeEvery(actions.FECHA_SENALADA_DELETE_REQUESTED, DELETE_FECHA_SENALADA),
    takeEvery(actions.FECHA_SENALADA_UPDATE_REQUESTED, UPDATE_FECHA_SENALADA),
    takeEvery(actions.FECHA_SENALADA_INSERT_REQUESTED, INSERT_FECHA_SENALADA),
    takeEvery(actions.FECHA_SENALADA_UPDATE_ALL_REQUESTED, UPDATE_FECHA_SENALADA_ALL),
  ])
}
